import { defineMessages } from 'react-intl';
import globalIntl from 'globalIntl'; // eslint-disable-line import/no-unresolved

const m = defineMessages({
  actorsFiltersTitle: {
    id: 'actorsFiltersTitle',
    defaultMessage: 'Filters',
  },
  actorsFiltersTitleCancel: {
    id: 'actorsFiltersTitleCancel',
    defaultMessage: 'Cancel',
  },
  advancedSettings: {
    id: 'advancedSettings',
    defaultMessage: 'Advanced search settings ',
  },
  actorDateRange: {
    id: 'actorDateRange',
    defaultMessage: 'Create date range',
  },
  resetFilters: {
    id: 'resetFilters',
    defaultMessage: 'Reset all',
  },
  saveActorsFilter: {
    id: 'saveActorsFilter',
    defaultMessage: 'Save as new filter',
  },
  updateActorsFilter: {
    id: 'updateActorsFilter',
    defaultMessage: 'Update filter',
  },
  submitSearchActors: {
    id: 'submitSearchActors',
    defaultMessage: 'Search',
  },
  createAndSelect: {
    id: 'createAndSelect',
    defaultMessage: 'Create and select',
  },
  all: {
    id: 'all',
    defaultMessage: 'All',
  },
});

export default { ...globalIntl, ...m };
